import React from 'react';
import { createPortal } from 'react-dom';
import AppointmentCreateForm from './AppointmentCreateForm';
import { useEscapeKey } from '../../hooks/useEscapeKey';

interface AppointmentCreateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (appointment?: any) => void;
  initialDate?: Date;
  initialEndTime?: Date;
  initialVetUserId?: string;
  initialPetOwnerId?: string;
  initialPetId?: string;
}

const AppointmentCreateModal: React.FC<AppointmentCreateModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  initialDate,
  initialEndTime,
  initialVetUserId,
  initialPetOwnerId,
  initialPetId
}) => {
  useEscapeKey(onClose, isOpen);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[500] bg-black bg-opacity-30 transition-opacity"
      onClick={onClose}
    >
      <div
        className="fixed right-0 top-0 h-full w-full max-w-2xl bg-white shadow-2xl transform transition-transform duration-300 ease-out overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ transform: isOpen ? 'translateX(0)' : 'translateX(100%)' }}
      >
        <AppointmentCreateForm
          onClose={onClose}
          onSuccess={onSuccess}
          initialDate={initialDate}
          initialEndTime={initialEndTime}
          initialVetUserId={initialVetUserId}
          initialPetOwnerId={initialPetOwnerId}
          initialPetId={initialPetId}
        />
      </div>
    </div>,
    document.body
  );
};

export default AppointmentCreateModal;

